import * as React from 'react'

import { Box, Chevron, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

interface Props {
  expanded: boolean
  totalQuestions: number
}

function QuestionHeader({ totalQuestions, expanded }: Props) {
  return (
    <>
      <Box
        flexDirection="row"
        paddingLeft="s32"
        paddingX="s16"
        borderRadius={{
          all: 'abs004',
        }}
        border={{
          all: {
            style: 'solid',
            width: 's1',
            color: 'grey400',
          },
        }}
        flexGrow
        cursor="pointer"
        background="grey200"
        expanded={expanded}
      >
        <Box justifyContent="center" paddingX="s2">
          <Chevron direction={expanded ? 'down' : 'right'} type="secondary" />
        </Box>
        <Box paddingY="s8" paddingX="s12" gap="s2" flexGrow>
          <Text.Normal color="grey1000" weight="medium" size="300">
            {i18n.t('surveys.form.question_categories.score_type_question')}
          </Text.Normal>
          <Text.Normal color="grey800" weight="medium" size="200">
            {i18n.tp('surveys.form.question_categories.question_configs_count', {
              count: totalQuestions,
            })}
          </Text.Normal>
        </Box>
      </Box>
    </>
  )
}

export default observer(QuestionHeader)
